import React, { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { FaBars, FaFacebookMessenger } from "react-icons/fa";
import { IoMdNotifications } from "react-icons/io";
import avatar from "../../assets/avatar.png";
import logo from "../../assets/logo.png";
import Input from "../Input";
import Notification from "../Notification";
import Popover from "../Popover";
import AvatarDropdownMenu from "./avatarDropdownMenu";
const Header = ({ show, setShow, openChat, setOpenChat }) => {
  const [search, setSearch] = useState("");
  console.log(search);
  // avater clckable menu
  const [openMenu, setOpenMenu] = useState(false);
  // notification
  const [openNotify, setOpenNotify] = useState(false);
  // message
  // const [openChat, setOpenChat] = useState(false);
  return (
    <div className="mono_header_wrapper">
      <div className="container">
        <div className="mono_header_container">
          <div className="mono_hamburger">
            <img src={logo} width="100%" className="mono_loog" alt="logo" />
            <FaBars className="hamburger_icon" onClick={() => setShow(!show)} />
            <div className="mono_searchbar">
              <Input
                type="text"
                name="search"
                className="mono_search_input"
                placeholder="Find something here..."
                onChange={(e) => setSearch(e.target.value)}
              />
              <span>
                <AiOutlineSearch />
              </span>
            </div>
          </div>
          <div className="mono_header_menu">
            <ul className="mono_header_menu_lists">
              <li className="mono_header_menu_list">
                <div
                  className="msg_icon"
                  onClick={() => setOpenChat(!openChat)}
                >
                  <FaFacebookMessenger />
                  <span>26</span>
                </div>
                {/* <Drawer openDrawer={openChat} setOpenDrawer={setOpenChat} className="chatting_box" >
                  <ChatBox setOpenDrawer={setOpenChat} />
                </Drawer> */}
              </li>
              <li className="mono_header_menu_list">
                <div
                  className="msg_icon"
                  onClick={() => setOpenNotify(!openNotify)}
                >
                  <IoMdNotifications />
                  <span>15</span>
                </div>
                <Popover
                  openPopover={openNotify}
                  setOpenPopover={setOpenNotify}
                  className="notification"
                >
                  <Notification setOpenNotify={setOpenNotify} />
                </Popover>
              </li>
              <li className="mono_header_menu_list">
                <img
                  src={avatar}
                  alt="user_pic"
                  onClick={() => setOpenMenu(!openMenu)}
                />
                <Popover
                  openPopover={openMenu}
                  setOpenPopover={setOpenMenu}
                  className="clickable_submenu"
                >
                  <AvatarDropdownMenu setOpenMenu={setOpenMenu} />
                </Popover>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
